import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button, Calendar, Tag } from 'primereact';


import Card from '../../../../Base/Components/Card/Card'
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import { getDatesProduccion, getDateTimeStringSQL, getDateTimeStringSQL24 } from '../../../../Base/Services/Moment/Luxon';
import { ArchivosExcelService } from '../../../../Base/Services/ArchivosService';


import { ingresosHilaza } from '../../../../API/Produccion/BodegaHilaza/BodegaHilazaRequests'
import { colorCotton, colorSintetico } from '../../../../Styles/Colors';
import CalendarioOperativo from '../../../../Base/Components/CalendarioOperativo/CalendarioOperativo';
import { getEncabezadosIngresosHilaza, postGenerarEncabezadoHilaza } from '../../../../API/Inventario/InventarioHilaza/IngresosHilazaRequest'
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import ModalCuentasPorPagarCompras from '../../../../Base/Screens/Proveedores/CuentasPorPagar/ModalCXP/ModalCuentasPorPagarCompras';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { getDateProduction } from '../../../../Base/Services/FechasService';
import { Checkbox } from 'primereact/checkbox';
import { postEstadoFinazasRegistros } from '../../../../Base/API/CuentasPorPagar/CXP/CuentasPorPagarRequest';
import { toastShow } from '../../../../Base/Services/ToastService';
import { Toast } from 'primereact/toast';
import Loader from '../../../../Base/Components/Loader/Loader';
import { getFechasCierre } from '../../../../Base/API/CalendarioFinanzas/CalendarioFinanzasRequest';
const IngresosHilazaScreen = ({ IngresoConsolidado = false }) => {

    const toast = useRef(null)
    const [ingresos, setIngresos] = useState([]);
    const [date, setDate] = useState([new Date(), new Date()]);
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState([])
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [selected, setSelected] = useState([]);
    const [diaologIngreso, setDialogIngreso] = useState(false)
    const [IdIngresoEnc, setIdIngresoEnc] = useState(null)
    const [infoIngreso, setInfoIngreso] = useState({});
    const [mesCierre, setMesCierre] = useState({})

    const { userAuth } = useContext(AuthContext);

    const obtenerInformacion = async () => {
        if (IngresoConsolidado) {
            setLoading(true)
            const result = await getEncabezadosIngresosHilaza(getDateProduction(dates));
            setData(result)
            setSelected([])
            setLoading(false)
        }
    }

    const categoryTemplate = (rowData) => {
        switch (rowData.Categoria) {
            case 'Cotton':
                return <Tag severity='danger' className='col-12' value={rowData.Categoria} style={{ backgroundColor: colorCotton }} />
                break;
            case 'Synthetic':
                return <Tag severity='info' className='col-12' value={rowData.Categoria} style={{ backgroundColor: colorSintetico }} />
                break;
            case 'Spandex':
                return <Tag className='col-12' value={rowData.Categoria} style={{ backgroundColor: '#ffc605' }} />
                break;

            default:
                return <div>{rowData.Categoria}</div>
                break;
        }
    }

    const statusTemplate = (rowData) => {
        switch (rowData.StatusName) {
            case 'Complete':
                return <Tag severity='danger' className='col-12' value={rowData.StatusName} style={{ backgroundColor: colorCotton }} />
            case 'Synthetic':
                return <Tag severity='info' className='col-12' value={rowData.StatusName} style={{ backgroundColor: colorSintetico }} />
                break;
            case 'Spandex':
                return <Tag className='col-12' value={rowData.StatusName} style={{ backgroundColor: '#ffc605' }} />
                break;
            default:
                return <div>{rowData.StatusName}</div>
                break;
        }
    }


    const columns = [
        {
            header: 'Categoria',
            field: 'Categoria',
            className: 'small',
            Format: 'Template',
            body: categoryTemplate
        },
        {
            header: 'CodigoProducto',
            field: 'CodigoProducto',
            className: 'medium',
            frozen: true,
        },
        {
            header: 'Hilaza',
            field: 'Hilaza',
            className: 'XXlarge',
            frozen: true,
        },
        {
            header: 'Fecha',
            field: 'FECHA',
            Format: 'DateTime'
        },
        {
            header: 'Cliente',
            field: 'CustomerName',
            className: 'large',
            Sumary: 'count'
        },
        {
            header: 'Reciclado',
            field: 'Reciclado',
            Format: 'Checkbox',
            className: 'Xsmall'
        },
        {
            header: 'Factura',
            field: 'Factura',
        },
        {
            header: 'Lot Name',
            field: 'LotName',
            className: 'medium'
        },
        {
            header: 'Cajas',
            field: 'BOX',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'Kgs',
            field: 'QtyIngresada',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'Lbs',
            field: 'QtyLbs',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'Precio $',
            field: 'Price',
            className: 'small',
            Format: 'Decimal'
        },
        {
            header: 'Monto $',
            field: 'Monto',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'Almacenaje',
            field: 'Almacenaje',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'CargoLocal',
            field: 'CargoLocal',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'OtrosCargos',
            field: 'OtrosCargos',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'ComposicionYarn2',
            field: 'ComposicionYarn2',
        },
        {
            header: 'ComposicionYarn1',
            field: 'ComposicionYarn1',
        },
        {
            header: 'Orden Compras',
            field: 'PurchaseOrder',
            className: 'small'
        },
        {
            header: 'Orden Ventas',
            field: 'SalesOrder',
            className: 'small'
        },
        {
            header: 'Orden Ingreso',
            field: 'OrdenIngreso',
            className: 'small'
        },
        {
            header: 'Camion',
            field: 'Camion',
            className: 'small'
        },
        {
            header: 'Tipo Ingreso',
            field: 'TipoIngreso',
            className: 'Xsmall'
        },
        {
            header: 'Bodega',
            field: 'Bodega',
            className: 'Xsmall',
            Format: 'Center'
        },
        {
            header: 'Vendor',
            field: 'Vendor',
            className: 'Xlarge'
        },
        {
            header: 'Fabricante',
            field: 'Fabricante',
            className: 'Xlarge'
        },
        {
            header: 'Origen',
            field: 'Origen',
            className: 'small'
        },
        {
            header: 'Terminos',
            field: 'TermName',
            className: 'small'
        },
        {
            header: 'Estado',
            field: 'StatusName',
            Format: 'Template',
            body: statusTemplate,
            className: 'small'
        },
        {
            header: 'Tipo Uso',
            field: 'TipoUso',
        },
        {
            header: 'Knitting Contract',
            field: 'KnittingContract',
            className: 'small'
        },
        {
            header: 'Ingresado Por',
            field: 'AgentName',
        },
        {
            header: 'Dev Type',
            field: 'DevType',
        },
        {
            header: 'Comentarios',
            field: 'Comentarios',
        },

    ];



    const table = {
        Columns: columns,
        Data: ingresos,
        loading: loading
    }

    const hideDialog = () => {
        setIdIngresoEnc(null)
        setInfoIngreso({})
        setDialogIngreso(false)
        obtenerInformacion()
    }

    const EstadoTemplate = (rowData) => {


        switch (rowData.IdEstadoFinanzas) {
            case 3580:
                return <Tag style={{ width: 80, backgroundColor: "rgb(227, 63, 63)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3607:
                return <Tag style={{ width: 80, backgroundColor: "rgb(217, 206, 41)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3581:
                return <Tag style={{ width: 80, backgroundColor: "rgb(0, 191, 57)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3713:
                return <Tag style={{ width: 100, backgroundColor: "rgb(63, 142, 227)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3714:
                return <Tag style={{ width: 100, backgroundColor: "rgba(125, 129, 126, 0.75)" }} value={rowData.EstadoFinanzas} />
                break;

            default:
                return <div><span>{rowData.EstadoFinanzas}</span></div>
                break;
        }
    }

    const DiasVencidos = (DiasVencidos) => {
        if (DiasVencidos < 0) {
            return (
                <span style={{ color: 'green', justifyContent: 'center', fontWeight: 'bold' }}
                    className='text-overFlow text-alingth-center d-flex'>{DiasVencidos}</span>
            )
        } else {
            return (
                <span style={{ color: 'red', justifyContent: 'center', fontWeight: 'bold' }}
                    className='text-overFlow text-alingth-center d-flex' >{DiasVencidos}</span>
            )
        }
    }

    const CrearEncabezadoHilaza = (det) => {

        let dataDet = det
    }

    const RecibirFactura = async () => {
        setLoading(true)

        if (selected.length > 0) {
            let registroValidos = selected.filter((s) => ([3713, 3580, 3714].includes(s?.IdEstadoFinanzas) === true) && s.IdIngresoEnc > 0)
            let datosEnviar = registroValidos?.map((r) => {
                return {
                    Id: r?.IdIngresoEnc,
                    IdEstadoFinanzas: ([3580, 3714].includes(r?.IdEstadoFinanzas)) ? 3713 : 3580,
                    IdUserEditCompras: userAuth.idUser,
                    FechaEdit: getDateTimeStringSQL(new Date()),
                    IdIngresoReferencia: r.IdIngresoEnc,
                    IdReferencia: 5,
                    IsRegistroManual: 0,
                    FechaRecibidoCompras: ([3580, 3714].includes(r?.IdEstadoFinanzas)) ? getDateTimeStringSQL24(new Date()) : null,
                    FechaRevisadoBodega: r.FechaRevisadoBodega
                }
            });
            let registrosIdEnc = []



            selected?.filter((s) => s.IdIngresoEnc <= 0 || s.IdIngresoEnc === null).map((d) => {
                let existe = registrosIdEnc.find((r) => r.IdProveedor === d.IdVendor && r.Factura === d.Factura && r.IdPO === d.IdPurchaseOrder)
                if (!existe) {
                    registrosIdEnc.push({
                        IdProveedor: d?.IdVendor,
                        Factura: d?.Factura,
                        IdPO: d?.IdPurchaseOrder,
                        IdEstadoFinanzas: ([3580, 3714].includes(d?.IdEstadoFinanzas)) ? 3713 : 3580,
                        FechaRecibidoCompras: ([3580, 3714].includes(d?.IdEstadoFinanzas)) ? getDateTimeStringSQL24(new Date()) : null,
                        FechaRevisadoBodega: null,
                        IdUserEditCompras: userAuth?.idUser,
                        IdUserIngresoCompras: userAuth?.idUser,
                        FechaInicio: d?.InicioMes,
                        FechaFinal: d?.FinMes
                    })
                } else {
                    return
                }

            });

            let actualizar = false
            // Crear Encabezado de CXP 
            if (registrosIdEnc.length > 0) {
                const tempoR = await postGenerarEncabezadoHilaza(registrosIdEnc)
                if (tempoR?.length > 0) {
                    if (tempoR[0]?.ERROR === 0) {
                        toastShow(toast, 'success', 'Registro Ingresado Correctamente')
                        actualizar = true
                    } else {
                        toastShow(toast, 'error', tempoR[0]?.MSJ)
                    }
                } else {
                    toastShow(toast, 'error', 'Ocurrio un problema al momento de ingresar la información')
                }
                setLoading(false)
            }
            if (datosEnviar.length > 0) {
                const result = await postEstadoFinazasRegistros(datosEnviar)
                if (result) {
                    if (result[0]?.ERROR === 0) {
                        actualizar = true
                        toastShow(toast, 'success', result[0]?.MSJ)
                        // obtenerInformacion()
                    }
                    else {
                        toastShow(toast, 'error', result[0]?.MSJ)
                    }
                }
                setLoading(false)
            }

            if (actualizar) {
                obtenerInformacion()
            }


            setSelected([])
        }

    }

    const RevisadoBodega = async () => {
        setLoading(true)
        if (selected.length > 0) {
            let registroValidos = selected.filter((s) => ([3580, 3714].includes(s?.IdEstadoFinanzas) === true) && s.IdIngresoEnc > 0)
            let datosEnviar = registroValidos?.map((r) => {
                return {
                    Id: r?.IdIngresoEnc,
                    IdEstadoFinanzas: r?.IdEstadoFinanzas === 3580 ? 3714 : 3580,
                    IdUserEditCompras: userAuth.idUser,
                    FechaEdit: getDateTimeStringSQL24(new Date()),
                    IdIngresoReferencia: r.IdIngresoEnc,
                    IdReferencia: 5,
                    IsRegistroManual: 0,
                    FechaRevisadoBodega: r?.IdEstadoFinanzas === 3580 ? getDateTimeStringSQL24(new Date()) : null,
                    FechaRecibidoCompras: null
                }
            });

            let registrosIdEnc = []

            selected?.filter((s) => s.IdIngresoEnc <= 0 || s.IdIngresoEnc === null).map((d) => {
                let existe = registrosIdEnc.find((r) => r.IdProveedor === d.IdVendor && r.Factura === d.Factura && r.IdPO === d.IdPurchaseOrder)
                if (!existe) {
                    registrosIdEnc.push({
                        IdProveedor: d?.IdVendor,
                        Factura: d?.Factura,
                        IdPO: d?.IdPurchaseOrder,
                        IdEstadoFinanzas: d?.IdEstadoFinanzas === 3580 ? 3714 : 3580,
                        FechaRevisadoBodega: d?.IdEstadoFinanzas === 3580 ? getDateTimeStringSQL(new Date()) : null,
                        FechaRecibidoCompras: null,
                    })
                } else {
                    return
                }

            });

            /// Crear Encabezado de CXP 
            if (registrosIdEnc.length > 0) {
                const tempoR = await postGenerarEncabezadoHilaza(registrosIdEnc)
                if (tempoR?.length > 0) {
                    if (tempoR[0]?.ERROR === 0) {
                        toastShow(toast, 'success', 'Registro Ingresado Correctamente')
                        obtenerInformacion()
                    } else {
                        toastShow(toast, 'error', tempoR[0]?.MSJ)
                    }
                } else {
                    toastShow(toast, 'error', 'Ocurrio un problema al momento de ingresar la información')
                }
                setLoading(false)
            }


            if (datosEnviar.length > 0) {
                const result = await postEstadoFinazasRegistros(datosEnviar)
                if (result) {
                    if (result[0]?.ERROR === 0) {
                        toastShow(toast, 'success', result[0]?.MSJ)
                        obtenerInformacion()
                    }
                    else {
                        toastShow(toast, 'error', result[0]?.MSJ)
                    }
                }
                setLoading(false)
            }
            setSelected([])
        }
    }

    const tablaIngresos = {
        Data: data,
        selected: selected,
        setSelected: setSelected,
        Columns: [
            {
                field: 'IdIngresoEnc',
                header: 'IdEnc',
                headerEn: 'IdEnc',
                className: 'small',
                width: 60,
                hidden: userAuth.IdRol === 1,
                frozen: true,
                alignFrozen: 'left',
            },
            {
                field: 'IdIngreso',
                header: 'Id Ingreso',
                headerEn: 'Id Ingreso',
                width: 60,
                className: 'Xsmall',
                frozen: true,
                alignFrozen: 'left',
                hidden: userAuth.IdRol === 1,
                Sumary: 'count'
            },
            {
                field: 'FECHA',
                header: 'Fecha',
                headerEn: 'Date',
                className: 'small',
                filter: true,
                Format: 'DateTime24',
                frozen: true,
                alignFrozen: 'left',
                sort: 'desc'
            },
            {
                field: 'EstadoFinanzas',
                header: 'EstadoFinanzas',
                headerEn: 'Finance Status',
                className: 'small',
                // Format: "Template",
                // body: (rowData) => EstadoTemplate(rowData),
                Format: 'Estado',
                body: (rowData) => ({
                    ID: rowData?.IdEstadoFinanzas,
                    Estado: rowData?.EstadoFinanzas
                }),
                frozen: true,
                alignFrozen: 'left',
            },
            {
                field: 'Categoria',
                header: 'Categoria',
                headerEn: 'Category',
                className: 'small',
                filter: true,
                Format: 'Template',
                body: categoryTemplate,
                frozen: true,
                alignFrozen: 'left',
            },
            {
                field: 'Factura',
                header: 'Factura',
                headerEn: 'Factura',
                className: 'medium',
                onCellDoubleClicked: ({ data }) => {
                    if (data.IdIngreso) {
                        if (data?.IdIngresoEnc > 0) {
                            setIdIngresoEnc(data?.IdIngresoEnc)

                        } else {
                            let detInfo = {
                                IdProveedor: data?.IdVendor,
                                Factura: data?.Factura,
                                IdPO: data?.IdPurchaseOrder,
                                FechaInicio: mesCierre?.FechaInicio,
                                FechaFinal: mesCierre?.FechaFinal
                            }
                            setInfoIngreso(detInfo)

                        }
                        setDialogIngreso(true)
                    }
                }
            },
            {
                field: 'Vendor',
                header: 'Proveedor',
                headerEn: 'Supplier',
                className: 'Xlarge',
                filter: true
            },
            {
                field: 'PurchaseOrder',
                header: 'Orden Compra',
                headerEn: 'Purchase Order',
                className: 'small',
            },
            {
                field: 'TerminoPagoN',
                header: 'TerminoPago',
                headerEn: 'Payment Term',
                className: 'small',
            },
            {
                field: 'FechaFactura',
                header: 'FechaFactura',
                headerEn: 'FechaFactura',
                className: 'small',
                Format: 'Date',
            },
            {
                field: 'FechaVencido',
                header: 'FechaVencido',
                headerEn: 'Expired Date',
                className: 'small',
                Format: 'Date',
            },
            {
                field: 'DiasVencidos',
                header: 'Dias Vencidos',
                headerEn: 'Expired Days',
                className: 'Xsmall',
                Format: 'Template',
                body: rowData => DiasVencidos(rowData.DiasVencidos)
            },
            {
                field: 'CodigoProducto',
                header: 'Codigo Producto',
                headerEn: 'Product Code',
                className: 'small',
                Sumary: 'count',
                align: "center",
            },
            {
                field: 'Hilaza',
                header: 'Hilaza',
                headerEn: 'Yarn',
                className: 'XXXlarge',
                align: "center",
                Sumary: 'count'
            },
            {
                field: 'LotName',
                header: 'Lote',
                headerEn: 'Lot Name',
                className: 'medium',
            },
            {
                field: 'CustomerName',
                header: 'Cliente',
                headerEn: 'Customer ',
                className: 'large',
            },
            {
                field: 'OrdenIngreso',
                header: 'Orden Ingreso',
                headerEn: 'Income Order',
                className: 'Xsmall',
                align: "center",
                Sumary: 'count'

            },
            {
                field: 'TipoIngreso',
                header: 'Tipo Ingreso',
                headerEn: 'Income Type',
                className: 'Xsmall',
            },
            {
                field: 'TermName',
                header: 'Terminos',
                headerEn: 'Termns',
                className: 'small',
            },
            {
                field: 'TipoUso',
                header: 'Tipo Uso',
                headerEn: 'Use Type',
                className: 'medium',
            },
            {
                field: 'QtyLbs',
                header: 'Lbs',
                className: 'Xsmall',
                Format: 'Currency',
                Sumary: 'sum',
            },
            {
                field: 'Id',
                header: 'Recibido ',
                headerEn: 'Recibido',
                className: 'Xsmall',
                Format: 'Template',
                frozen: true,
                alignFrozen: 'right',
                body: (data) => data.IdIngreso ? (
                    <div onClick={() => { if (selected.length === 0) setSelected([data]) }}
                        onDoubleClick={() => { if ([3713, 3580, 3714].includes(data?.IdEstadoFinanzas)) RecibirFactura() }} className='d-flex flex-row' style={{ justifyContent: 'center' }}>
                        <Checkbox checked={[3581, 3607, 3713].includes(data?.IdEstadoFinanzas)} disabled={[3581, 3607].includes(data?.IdEstadoFinanzas)} />
                    </div>
                ) : null,
            },
            // {
            //     field: 'Id',
            //     header: 'Revisado Bodega ',
            //     headerEn: 'Revisado Bodega',
            //     className: 'Xsmall',
            //     Format: 'Template',
            //     frozen: true,
            //     alignFrozen: 'right',
            //     body: (data) => data.IdIngreso ? (
            //         <div onClick={() => { if (selected.length === 0) setSelected([data]) }}
            //             onDoubleClick={() => { if ([3580,3714].includes(data?.IdEstadoFinanzas)) RevisadoBodega() }} className='d-flex flex-row' style={{ justifyContent: 'center' }}>
            //             <Checkbox checked={[3581, 3607, 3713, 3714].includes(data?.IdEstadoFinanzas)} 
            //             disabled={[3581, 3607, 3713].includes(data?.IdEstadoFinanzas)}
            //              />
            //         </div>
            //     ) : null,
            // },
            {
                field: 'QtyIngresada',
                header: 'Kgs',
                className: 'Xsmall',
                Format: 'Currency',
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right',
                editable: userAuth.IdRol === 1
            },
            {
                field: 'PrecioLiquidacionL',
                header: 'Precio L',
                headerEn: 'Price L',
                className: 'Xsmall',
                filter: true,
                Format: 'Currency',
            },
            {
                field: 'PrecioLiquidacionD',
                header: 'Precio $',
                headerEn: 'Price $',
                className: 'Xsmall',
                filter: true,
                Format: 'Currency',
            },

            {
                field: 'CostoL',
                header: 'Monto L',
                headerEn: 'Cost L',
                className: 'small',
                filter: true,
                Format: 'Currency',
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right',
            },
            {
                field: 'CostoD',
                header: 'Monto $',
                headerEn: 'Cost $',
                className: 'small',
                filter: true,
                Format: 'Currency',
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right',
            },
        ]
    }


    const getInfo = async () => {
        setLoading(true)
        const fechas = getDatesProduccion(date);
        const a = await ingresosHilaza(fechas);
        const tempoMesCierre = await getFechasCierre(5)

        if (tempoMesCierre?.length > 0) {
            const fechasProduccion = getDateProduction([new Date(tempoMesCierre[0]?.InicioMes), new Date(tempoMesCierre[0]?.FinMes)])
            setMesCierre({
                ...tempoMesCierre[0],
                FechaInicio: fechasProduccion[0],
                FechaFinal: fechasProduccion[1]
            })
        }
        setIngresos(a);
        setLoading(false)
    }


    const exportarExcel = () => {
        const t = ingresos.map(i => {
            let data = {}
            columns.forEach(col => {
                data[col.header] = i[col.field]
            })
            return data;
        })
        ArchivosExcelService(t, 'Ingresos Hilaza')
    }


    useEffect(() => {
        window.document.title = 'PPF • Ingresos Hilaza';
        getInfo()
    }, [])




    return (
        <div className='p-3'>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Loader loading={loading} querySelector={'#IngresosHilaza'} />
            {!IngresoConsolidado ?
                <Card
                    titulo={<div className='d-flex' style={{ alignItems: 'center' }}>
                        <h3>Ingresos Hilaza</h3>
                        <span className='mx-3'>Rango Fechas:</span>
                        <Calendar
                            id="monthpicker"
                            value={date}
                            onChange={(e) => setDate(e.value)}
                            selectionMode='range'
                            dateFormat="dd/mm/yy"
                            showIcon
                            className='mx-1'
                            showButtonBar={true}
                        />
                        <Button className='mx-1' icon={'pi pi-search'} onClick={e => getInfo()} />
                        <Button icon={'pi pi-file-excel'} className='p-button-success mx-1' onClick={e => { exportarExcel() }} />
                    </div>}
                    contenido={<div className='p-4' style={{ height: '85vh' }}>
                        <AgGrid table={table} />
                    </div>}
                />
                :
                <Card
                    titulo={<div>
                        <CalendarioOperativo
                            getInfo={getEncabezadosIngresosHilaza}
                            data={data}
                            setData={setData}
                            Nombre={'Ingresos Quimicos'}
                            selected={selected}
                            setSelected={setSelected}
                            dates={dates}
                            setDates={setDates}
                            type='Month'
                            loading={loading}
                            setLoading={setLoading}
                        />
                    </div>}
                    contenido={<div className='pt-4' style={{ height: '85vh' }} id='IngresosHilaza'>

                        <AgGrid table={tablaIngresos} />
                    </div>}
                />
            }
            <ModalCuentasPorPagarCompras
                dialogCuentas={diaologIngreso}
                hideDialog={hideDialog}
                IdFactura={IdIngresoEnc}
                InfoIngreso={infoIngreso}
            />
        </div>


    )
}

export default IngresosHilazaScreen